import {Logic} from '../Type'

export class MenuState extends Logic.Type {
    public Open = false
}